import { render } from "./ShowClientCategory.vue?vue&type=template&id=7f04daf3"
import script from "./ShowClientCategory.vue?vue&type=script&lang=js"
export * from "./ShowClientCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__